export default "__VITE_ASSET__7b8584b5__"